export type FieldPrefix =
  | 'Project'
  | 'Opex'
  | 'Capex'
  | 'Credit'
  | 'LeasingContract'
  | 'OwnFund'
  | 'WorkingCapitalParameter'
  | 'AdvancedProduct'
  | 'StandardProduct'
  | 'TaxMin'
  | 'TaxStandard'
  | 'TaxSpecial';

export type ItemValidator = {
  id: number;
  field: `${FieldPrefix}.${string}`;
  required: boolean;
  desirable: boolean;
};
